import styled, { css } from "styled-components";

export const ContainerBaseMeuApeWrapper = styled.div`
  .headroom-wrapper {
    h1 {
      display: block !important;
      color: #242625;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      margin-left: 12px;
    }
  }

  ${({ iconShort }) =>
    iconShort &&
    css`
      a {
        margin-left: 8px;
        display: flex;
      }
    `}
`;
